import { Component, TemplateRef } from '@angular/core';
import { ToastService } from '../toasts.service';
@Component({
  selector: 'app-toast-container2',
  templateUrl: './toast-container.component.html',
  host: { '[class.ngb-toasts]': 'true' }
})
export class ToastContainerComponent {
  constructor(public toastService: ToastService) {}

  isTemplate(toast) {
    return toast.textOrTpl instanceof TemplateRef;
  }
}
